import anime from 'animejs';
import raf from './raf';

export const cursors = {
  MOVE: `${window.publicPath}images/cursors/move.svg`,
  VIEW: `${window.publicPath}images/cursors/view-2.svg`,
  PLAY: `${window.publicPath}images/cursors/play.svg`,
  CLOSE: `${window.publicPath}images/cursors/close.svg`,
};

Object.keys(cursors).forEach((key) => {
  const i = new Image();
  i.src = cursors[key];
});

const cursor = {};
let x;
let y;
let cx = x;
let cy = y;
let visible = false;
let cvisible = visible;
let bg = '';
let cbg = bg;

const el = document.createElement('div');
el.classList.add('cursor');

export const animationFrame = () => {
  if (bg !== cbg) {
    cbg = bg;
    anime.set(el, { backgroundImage: `url(${cbg})` });
  }
  if (cvisible !== visible) {
    cvisible = visible;
    el.classList.toggle('cursor_show', cvisible);
  }
  if (cvisible && cx !== x && cy !== y && (((x - cx) ** 2) + ((y - cy) ** 2) > 1e-2)) {
    cx += 0.2 * (x - cx);
    cy += 0.2 * (y - cy);
    anime.set(el, { translateX: cx, translateY: cy });
  } else if (cx !== x && cy !== y) {
    cx = x;
    cy = y;
    anime.set(el, { translateX: cx, translateY: cy });
  }
};

cursor.toggle = (_visible) => {
  visible = _visible;
};

cursor.setPosition = (_x, _y) => {
  x = _x;
  y = _y;
};

cursor.setBgImage = (_bg) => {
  bg = _bg;
  el.classList.toggle('cursor_dot', _bg === cursors.VIEW);
};

document.body.appendChild(el);
if (!window.isMobile.any) {
  raf(animationFrame);
}

export default cursor;
